import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { Facebook as LoadingState } from 'react-content-loader';
import * as yup from 'yup';
import TwitterText from 'twitter-text';
import { useTranslation } from 'react-i18next';
import { yupResolver } from '@hookform/resolvers';
import {
  ICampaigns,
  IOriginalContent
} from 'redux/slices/Campaigns/Campaigns.interface';
import {
  selectGroupAmbassador,
  setData,
  setLoadingGroupAmbassador
} from 'redux/slices/GroupAmbassador/GroupAmbassadorSlice';
import { selectUser } from 'redux/slices/userSlice';
import {
  Igroup,
  IGroupAmssador
} from 'redux/slices/GroupAmbassador/GroupAmbassador.interface';
import {
  CampaignData,
  updateCampaign
} from 'services/rest/Campaign/createCampaign';
import { getGroupAmbassador } from 'services/rest/GetGroupAmbassador/GetGroupAmbassador';
import { getCompanyCampaignsId } from 'services/rest/Campaign/getCompanyCampaigns';
import { RequiredString } from 'helpers/yupHelper';
import {
  awsUploadFileHelper,
  setFileNameHelper,
  setFilePdfHelper
} from 'helpers/awsCampaignFileHelper';
import { awsUploadVideoHelper } from 'helpers/awsVideoHelper';
import { sortGroups } from 'helpers/groupsHelper';
import { getUrlS3 } from 'constants/setup.constants';
import { generateRandAlphaNumStr } from 'Utils/StringRandom';
import { facebookURLs } from 'Utils/FacebookURLs';
import { SuccessAlert, ErrorAlert } from 'components/Alert';
import { validIgUrl, validTkUrl } from 'helpers/socialUrlValidate';
import EditCampaignForm from './EditCampaignForm';

interface CampaignParams {
  campaignId: string;
}

const EditCampaignNewPage: React.FC = () => {
  const { t } = useTranslation(['campaigns_page', 'validations']);
  const dispatch = useDispatch();
  const { campaignId } = useParams<CampaignParams>();

  const [campaign, setCampaign] = useState<ICampaigns>();
  const [loadingCampaigns, setLoadingCampaigns] = useState(true);

  const userSchema = yup.object().shape({
    name: RequiredString()
      .max(150, t('validations:length_error', { max: 150 }))
      .trim()
      .required(t('validations:required'))
      .test('not-blank', t('validations:required'), value => {
        return !!(value && value.trim().length > 0);
      })
  });

  const { register, control, handleSubmit, errors } = useForm({
    resolver: yupResolver(userSchema)
  });

  useEffect(() => {
    dispatch(setLoadingGroupAmbassador(true));
    getData();
  }, []);
  const [backendError, setBackendError] = useState<string | null>(null);
  const [startDate, setStartDate] = useState<any>('');
  const [finishDate, setFinishDate] = useState<any>('');
  const [firstFinishDate, setFirstFinishDate] = useState<any>('');
  const [checkBox, setCheckBox] = useState(false);
  const [hourt, setHourt] = useState<any>('00');
  const [minutes, setMinutes] = useState<any>('00');
  const [saveDraft, setSaveDraft] = useState(false);
  const [allowFBFanpage, setAllowFBFanpage] = useState(false);
  const [image, setImage] = useState<Array<any>>([]);
  const [imageFacebook, setImageFacebook] = useState<Array<any>>([]);
  const [imageTwitter, setImageTwitter] = useState<Array<any>>([]);
  const [imageLinkedin, setImageLinkedin] = useState<Array<any>>([]);
  const [imageInstagram, setImageInstagram] = useState<Array<any>>([]);
  const [imageWhatsapp, setImageWhatsapp] = useState<Array<any>>([]);
  const [imageTiktok, setImageTiktok] = useState<Array<any>>([]);
  const [campaignStatus, setCampaignStatus] = useState('');
  const [group, setGroup] = useState<Array<number>>([]);
  const [ambassadors, setAmbassadors] = useState<Array<number>>([]);
  const [backendSuccess, setBackendSuccess] = useState<string | null>(null);

  const [type, setType] = useState({
    facebook: 'share',
    twitter: 'text',
    linkedin: 'text',
    instagram: 'text',
    whatsapp: 'text',
    tiktok: 'text'
  });

  const [loader, setLoader] = useState(false);
  const history = useHistory();
  const [editImage, setEditImage] = useState({
    photo: false,
    facebook: false,
    twitter: false,
    linkedin: false,
    instagram: false,
    tiktok: false,
    whatsapp: false
  });

  const { currentUser } = useSelector(selectUser);
  const { groupsAmbassador = [] } = useSelector(selectGroupAmbassador);

  const contentLimits = {
    facebook: 280,
    twitter: 280,
    linkedin: 1500,
    instagram: 700,
    tiktok: 150,
    whatsapp: 280
  };

  const [invalidLimit, setInvalidLimit] = useState({
    facebook: false,
    twitter: false,
    linkedin: false,
    instagram: false,
    tiktok: false,
    whatsapp: false
  });

  const no_characters = /^(?!.*[!@#$%^&*()\-_+={}[\]|\\;:'"ª|!· º\\,<.>/?]{5}).+/;
  const no_mentions = /^(?!.*(?:\B@|https?:\/\/|www\.|\b[\w-]+\.(?:com|net|org|io|co|me|tv|app|ly|gg)\b))[\s\S]+$/i;
  const [uploadedFacebook, setUploadedFacebook] = useState<boolean | null>(
    null
  );
  const [uploadedTwitter, setUploadedTwitter] = useState<boolean | null>(null);
  const [uploadedLinkedin, setUploadedLinkedin] = useState<boolean | null>(
    null
  );
  const [uploadedInstagram, setUploadedInstagram] = useState<boolean | null>(
    null
  );
  const [uploadedTiktok, setUploadedTiktok] = useState<boolean | null>(null);
  const [uploadedWhatsapp, setUploadedWhatsapp] = useState<boolean | null>(
    null
  );

  const [linkedinUrn, setLinkedinUrn] = useState('');
  const [linkedinUrnError, setLinkedinUrnError] = useState('');
  const [instagramShareUrl, setInstagramShareUrl] = useState('');
  const [instagramShareUrlError, setInstagramShareUrlError] = useState('');
  const [tiktokShareUrl, setTiktokShareUrl] = useState('');
  const [tiktokShareUrlError, setTiktokShareUrlError] = useState('');

  const [socialContent, setSocialContent] = useState<{
    twitter: {
      [key: string]: string;
    };
    linkedin: {
      [key: string]: string;
    };
    tiktok: {
      [key: string]: string;
    };
  }>({
    twitter: {
      content: ''
    },
    linkedin: {
      content: ''
    },
    tiktok: {
      content: ''
    }
  });

  const loadMultipleContents = () => {
    const multipleContents = ['linkedin', 'twitter', 'tiktok'];
    for (const social of multipleContents) {
      if (
        campaign?.contentPerSocialNetwork[
          social as keyof ICampaigns['contentPerSocialNetwork']
        ]
      ) {
        Object.keys(
          campaign?.contentPerSocialNetwork[
            social as keyof ICampaigns['contentPerSocialNetwork']
          ]
        )
          .filter(key => {
            return key.includes('content');
          })
          .forEach((key: string) => {
            if (['content', 'content2', 'content3'].includes(key)) {
              const value = campaign?.contentPerSocialNetwork?.[
                social as keyof ICampaigns['contentPerSocialNetwork']
              ][key as keyof IOriginalContent] as string;

              setSocialContent(prev => ({
                ...prev,
                [social]: {
                  ...prev[social as 'linkedin' | 'twitter' | 'tiktok'],
                  [key]: value
                }
              }));
            }
          });
      }
    }
  };

  const getData = async () => {
    await getCompanyCampaignsId(currentUser?.token, Number(campaignId))
      .then(result => {
        setCampaign(result.data.data);
        setLoadingCampaigns(false);
        setCheckBox(result.data.data.allowExtraDates);
      })
      .catch(error => {
        setLoadingCampaigns(false);
      });
  };

  useEffect(() => {
    if (campaign) {
      const facebookContent =
        campaign?.contentPerSocialNetwork?.facebook?.content;
      setAllowFBFanpage(!!facebookContent);
      setStartDate(campaign?.startDate ? new Date(campaign.startDateUTC) : '');
      setFinishDate(campaign?.finishDate ? new Date(campaign.finishDate) : '');
      setHourt(new Date(campaign.startDateUTC).getHours());
      setMinutes(new Date(campaign.startDateUTC).getMinutes());
      setType({
        facebook: campaign?.contentPerSocialNetwork?.facebook?.type
          ? campaign?.contentPerSocialNetwork?.facebook?.type
          : 'share',
        twitter: campaign?.contentPerSocialNetwork?.twitter?.type
          ? campaign?.contentPerSocialNetwork?.twitter?.type
          : 'text',
        linkedin: campaign?.contentPerSocialNetwork?.linkedin?.type
          ? campaign?.contentPerSocialNetwork?.linkedin?.type
          : 'text',
        instagram: campaign?.contentPerSocialNetwork?.instagram?.type
          ? campaign?.contentPerSocialNetwork?.instagram?.type
          : 'text',
        tiktok: campaign?.contentPerSocialNetwork?.tiktok?.type
          ? campaign?.contentPerSocialNetwork?.tiktok?.type
          : 'text',
        whatsapp: campaign?.contentPerSocialNetwork?.whatsapp?.type
          ? campaign?.contentPerSocialNetwork?.whatsapp?.type
          : 'text'
      });
      setGroup(campaign?.groupsIds ? campaign.groupsIds : []);
      setAmbassadors(campaign?.ambassadorsIds ? campaign.ambassadorsIds : []);
      setImage(campaign?.photo ? [campaign.photo] : []);
      setInstagramShareUrl(
        campaign?.contentPerSocialNetwork?.instagram?.type === 'share'
          ? campaign?.contentPerSocialNetwork?.instagram?.url || ''
          : ''
      );
      setTiktokShareUrl(
        campaign?.contentPerSocialNetwork?.tiktok?.type === 'share'
          ? campaign?.contentPerSocialNetwork?.tiktok?.url || ''
          : ''
      );
      setFirstFinishDate(
        campaign?.finishDate ? new Date(campaign.finishDate) : ''
      );
      setCampaignStatus(campaign?.status);
      loadMultipleContents();
    }
  }, [campaign]);

  if (loadingCampaigns) {
    return <LoadingState height="230px" width="100%" />;
  }

  const onSelectedSocialNetwork = (
    socialNetwork: string,
    file: any,
    isEdit: boolean
  ) => {
    const socialNetworkSelected = editImage as any;
    const socialNetworks = {
      ...socialNetworkSelected,
      [socialNetwork]: isEdit
    };
    setEditImage(socialNetworks);
  };

  const handleClick = (
    startDate: Date,
    finishDate: Date,
    hour: string,
    minutes: string
  ) => {
    const dateStart = new Date(
      `${startDate.getFullYear()}/${
        startDate.getMonth() + 1
      }/${startDate.getDate()} ${hour}:${minutes}`
    );

    const dateFinish = new Date(
      `${finishDate.getFullYear()}/${
        finishDate.getMonth() + 1
      }/${finishDate.getDate()} 22:59:59`
    );

    setStartDate(dateStart);
    setFinishDate(dateFinish);
  };

  const handleImagen = (select: Array<any>, content: string) => {
    switch (content) {
      case 'photo':
        setImage(select);
        onSelectedSocialNetwork('photo', select, true);
        break;
      case 'facebook':
        setImageFacebook(select);
        onSelectedSocialNetwork('facebook', select, true);
        break;
      case 'twitter':
        setImageTwitter(select);
        onSelectedSocialNetwork('twitter', select, true);
        break;
      case 'linkedin':
        setImageLinkedin(select);
        onSelectedSocialNetwork('linkedin', select, true);
        break;
      case 'instagram':
        setImageInstagram(select);
        onSelectedSocialNetwork('instagram', select, true);
        break;
      case 'tiktok':
        setImageTiktok(select);
        onSelectedSocialNetwork('tiktok', select, true);
        break;
      case 'whatsapp':
        setImageWhatsapp(select);
        onSelectedSocialNetwork('whatsapp', select, true);
        break;
    }
  };

  const handleParticipation = (
    group: Array<Igroup>,
    ambassadors: Array<Igroup>
  ) => {
    const groupsIds = group.map(select => select.id);
    const ambassadorsIds = ambassadors.map(select => select.id);

    setGroup(groupsIds);
    setAmbassadors(ambassadorsIds);
  };

  const handleTypeFile = (body: any) => {
    setType(body);
  };

  const getGroup = async (name: string) => {
    await getGroupAmbassador(currentUser?.token, 1, 500, name)
      .then(response => {
        const group = sortGroups(response.data.data.groups.docs);
        const ambassadors = sortGroups(response.data.data.ambassadors.docs);
        const groupAmbassador: IGroupAmssador = {
          groups: group,
          ambassador: ambassadors
        };
        dispatch(setData(groupAmbassador));
        dispatch(setLoadingGroupAmbassador(false));
      })
      .catch(error => {
        dispatch(setLoadingGroupAmbassador(false));
      });
  };

  const regextValidationTwitter = (content: string) => {
    const regex = new RegExp(no_characters);
    return regex.test(content);
  };

  const regextValidationTiktok = (content: string) => {
    const regex = new RegExp(no_mentions);
    return regex.test(content);
  };

  const onSubmit = async (campaignData: CampaignData) => {
    setLoader(true);

    if (!campaignData.description && !saveDraft) {
      setBackendError(t('description_required'));
      setLoader(false);
      return;
    } else if (campaignData.description.length > 700 && !saveDraft) {
      setBackendError(t('description_length', { max: 700 }));
      setLoader(false);
      return;
    }

    const startYear = startDate.getFullYear();
    const finishYear = finishDate.getFullYear();
    const startMonth = startDate.getMonth();
    const finishMonth = finishDate.getMonth();
    const monthDifference =
      (finishYear - startYear) * 12 + (finishMonth - startMonth);

    if (campaignData?.allowExtraDates) {
      if (monthDifference != 1) {
        setBackendError(t('date_range_month_error'));
        setLoader(false);
        return;
      }
    } else {
      if (finishMonth != startMonth) {
        setBackendError(t('date_range_error'));
        setLoader(false);
        return;
      }
    }

    if (image.length === 0) {
      campaignData.photo = '';
    }

    if (image.length === 0 && !saveDraft) {
      setBackendError(t('campaigns_page:image_required'));
      setLoader(false);
      return;
    }

    if (startDate == '' && finishDate == '') {
      setBackendError(t('error_date'));
      setLoader(false);
      return;
    }
    if (campaignStatus != 'pending' && campaignStatus != 'draft') {
      if (firstFinishDate.getMonth() != finishDate.getMonth()) {
        setBackendError(t('end_date_error'));
        setLoader(false);
        return;
      }
    }

    if (campaignStatus == 'paused' || !saveDraft) {
      const finishDateNew = finishDate;
      const today = new Date();
      finishDateNew.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);
      if (finishDateNew < today) {
        setBackendError(t('end_date_today_error'));
        setLoader(false);
        return;
      }
    }

    if (ambassadors.length == 0 && group.length == 0 && !saveDraft) {
      setBackendError(t('error_info_ambassador'));
      setLoader(false);
      return;
    }

    if (
      !campaignData.includesFacebook &&
      !campaignData.includesTwitter &&
      !campaignData.includesLinkedin &&
      !campaignData.includesInstagram &&
      !campaignData.includesWhatsapp &&
      !campaignData.includesTiktok &&
      !saveDraft
    ) {
      setBackendError(t('error_social_network'));
      setLoader(false);
      return;
    }

    const pointsValue: any = {
      facebook: { ...campaignData?.facebook },
      twitter: { ...campaignData?.twitter },
      linkedin: { ...campaignData?.linkedin },
      instagram: { ...campaignData?.instagram },
      tiktok: { ...campaignData?.tiktok },
      whatsapp: { ...campaignData?.whatsapp }
    };
    for (const network in pointsValue) {
      const isEmptyPoint = Object.values(pointsValue[network]).some(
        point => point === null || point === ''
      );
      if (isEmptyPoint && !saveDraft) {
        setBackendError(t('error_sn_points'));
        setLoader(false);
        return;
      }
    }

    if (
      campaignData.includesFacebook &&
      !facebookURLs(campaignData.linkFacebook) &&
      !saveDraft
    ) {
      setBackendError(t('error_url'));
      setLoader(false);
      return;
    }

    if (campaignData.includesFacebook && allowFBFanpage) {
      const urlPattern = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/g;
      const countPattern = (
        (campaignData.contentFacebook || '').match(urlPattern) || []
      ).length;
      const urlWeight = 33;
      const contentFacebookLength = campaignData.contentFacebook
        ? campaignData.contentFacebook
            .replace(/(?:https?|ftp):\/\/\S+|www\.\S+/g, ' ')
            .trim().length +
          countPattern * urlWeight
        : 0;

      if (allowFBFanpage && !campaignData.contentFacebook && !saveDraft) {
        setBackendError(t('error_text_fanpage'));
        setLoader(false);
        return;
      } else if (contentFacebookLength > contentLimits.facebook && !saveDraft) {
        setBackendError(t('error_limit'));
        setInvalidLimit({
          ...invalidLimit,
          facebook: true
        });
        setLoader(false);
        return;
      }
      if (
        type.facebook !== 'share' &&
        Object.keys(imageFacebook).length == 0 &&
        !saveDraft
      ) {
        setBackendError(t('error_info_fanpage'));
        setLoader(false);
        return;
      }
    }

    if (campaignData.includesTwitter) {
      for (const key of Object.keys(socialContent.twitter)) {
        const validationContent = regextValidationTwitter(
          socialContent.twitter[key]
        );
        const contentTwitterLength = socialContent.twitter[key]
          ? TwitterText.getTweetLength(socialContent.twitter[key])
          : 0;
        if (!socialContent.twitter[key] && !saveDraft) {
          setBackendError(t('error_text_twitter'));
          setLoader(false);
          return;
        } else if (!validationContent && !saveDraft) {
          setBackendError(t('characters'));
          setLoader(false);
          return;
        } else if (contentTwitterLength > contentLimits.twitter && !saveDraft) {
          setBackendError(t('error_limit'));
          setInvalidLimit({
            ...invalidLimit,
            twitter: true
          });
          setLoader(false);
          return;
        }
      }
      campaignData.twitterContents = socialContent.twitter;
    }

    if (
      type.twitter !== 'text' &&
      campaignData.includesTwitter &&
      Object.keys(imageTwitter).length == 0 &&
      !saveDraft
    ) {
      setBackendError(t('error_info_twitter'));
      setLoader(false);
      return;
    }

    if (campaignData.includesLinkedin) {
      for (const key of Object.keys(socialContent.linkedin)) {
        const urlPattern = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/g;
        const countPattern = (
          (socialContent.linkedin[key] || '').match(urlPattern) || []
        ).length;
        const urlWeight = 33;
        const contentLinkedinLength = socialContent.linkedin[key]
          ? socialContent.linkedin[key]
              .replace(/(?:https?|ftp):\/\/\S+|www\.\S+/g, ' ')
              .trim().length +
            countPattern * urlWeight
          : 0;
        if (
          (type.linkedin === 'text' || type.linkedin === 'share') &&
          !socialContent.linkedin[key] &&
          !saveDraft
        ) {
          setBackendError(t('error_text_linkedin'));
          setLoader(false);
          return;
        } else if (
          contentLinkedinLength > contentLimits.linkedin &&
          !saveDraft
        ) {
          setBackendError(t('error_limit'));
          setInvalidLimit({
            ...invalidLimit,
            linkedin: true
          });
          setLoader(false);
          return;
        }
      }
      if (type.linkedin != 'share') {
        campaignData.linkedinContents = socialContent.linkedin;
      } else {
        if (
          type.linkedin === 'share' &&
          !campaignData.contentLinkedinShare &&
          !saveDraft
        ) {
          setBackendError(t('error_text_linkedin'));
          setLoader(false);
          return;
        } else if (type.linkedin === 'share' && !linkedinUrn && !saveDraft) {
          setLinkedinUrnError(t('error_urn_linkedin'));
          setLoader(false);
          return;
        }
        campaignData.linkedinContents = campaignData.contentLinkedinShare;
      }
    }

    if (
      campaignData.includesLinkedin &&
      ['image', 'video', 'pdf'].includes(type.linkedin) &&
      Object.keys(imageLinkedin).length == 0 &&
      !saveDraft
    ) {
      setBackendError(t('error_info_linkedin'));
      setLoader(false);
      return;
    }

    if (campaignData.includesInstagram) {
      const urlPattern = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/g;
      const countPattern = (
        (campaignData.contentInstagram || '').match(urlPattern) || []
      ).length;
      const urlWeight = 33;
      const contentInstagramLength = campaignData.contentInstagram
        ? campaignData.contentInstagram
            .replace(/(?:https?|ftp):\/\/\S+|www\.\S+/g, ' ')
            .trim().length +
          countPattern * urlWeight
        : 0;

      if (contentInstagramLength > contentLimits.instagram && !saveDraft) {
        setBackendError(t('error_limit'));
        setInvalidLimit({
          ...invalidLimit,
          instagram: true
        });
        setLoader(false);
        return;
      }

      if (type.instagram === 'share') {
        if (!instagramShareUrl && !saveDraft) {
          setInstagramShareUrlError(t('error_url_instagram'));
          setBackendError(t('error_url_instagram'));
          setLoader(false);
          return;
        }

        if (instagramShareUrl && !validIgUrl(instagramShareUrl) && !saveDraft) {
          setInstagramShareUrlError(t('error_url_instagram'));
          setBackendError(t('error_url_instagram'));
          setLoader(false);
          return;
        }

        setInstagramShareUrlError('');
      } else if (Object.keys(imageInstagram).length == 0 && !saveDraft) {
        setBackendError(t('error_info_instagram'));
        setLoader(false);
        return;
      }
    }

    if (campaignData.includesWhatsapp) {
      const urlPattern = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/g;
      const countPattern = (
        (campaignData.contentWhatsapp || '').match(urlPattern) || []
      ).length;
      const urlWeight = 33;
      const contentWhatsappLength = campaignData.contentWhatsapp
        ? campaignData.contentWhatsapp
            .replace(/(?:https?|ftp):\/\/\S+|www\.\S+/g, ' ')
            .trim().length +
          countPattern * urlWeight
        : 0;

      if (Object.keys(imageWhatsapp).length == 0 && !saveDraft) {
        setBackendError(t('error_info_whatsapp'));
        setLoader(false);
        return;
      } else if (contentWhatsappLength > contentLimits.whatsapp && !saveDraft) {
        setBackendError(t('error_limit'));
        setInvalidLimit({
          ...invalidLimit,
          whatsapp: true
        });
        setLoader(false);
        return;
      }
    }

    if (campaignData.includesTiktok) {
      for (const key of Object.keys(socialContent.tiktok)) {
        const validationContent = regextValidationTiktok(
          socialContent.tiktok[key]
        );
        const urlPattern = /((https?:\/\/)?(www\.)?[a-zA-Z0-9][a-zA-Z0-9-]+\.[a-zA-Z]{2,}([/\w .-]*)?)/g;
        const countPattern = (
          (socialContent.tiktok[key] || '').match(urlPattern) || []
        ).length;
        const urlWeight = 33;
        const contentTiktokLength = socialContent.tiktok[key]
          ? socialContent.tiktok[key]
              .replace(/(?:https?|ftp):\/\/\S+|www\.\S+/g, ' ')
              .trim().length +
            countPattern * urlWeight
          : 0;
        if (!socialContent.tiktok[key] && !saveDraft) {
          setBackendError(t('error_text_tiktok'));
          setLoader(false);
          return;
        } else if (socialContent.tiktok[key].match(urlPattern) && !saveDraft) {
          setBackendError(t('error_no_urls'));
          setLoader(false);
          return;
        } else if (!validationContent && !saveDraft) {
          setBackendError(t('pattern_tiktok'));
          setLoader(false);
          return;
        } else if (contentTiktokLength > contentLimits.tiktok && !saveDraft) {
          setBackendError(t('error_limit'));
          setInvalidLimit({
            ...invalidLimit,
            tiktok: true
          });
          setLoader(false);
          return;
        }
      }
      if (type.tiktok === 'share') {
        if (!tiktokShareUrl && !saveDraft) {
          setTiktokShareUrlError(t('error_url_tiktok'));
          setBackendError(t('error_url_tiktok'));
          setLoader(false);
          return;
        }

        if (tiktokShareUrl && !validTkUrl(tiktokShareUrl) && !saveDraft) {
          setTiktokShareUrlError(t('error_url_tiktok'));
          setBackendError(t('error_url_tiktok'));
          setLoader(false);
          return;
        }

        setTiktokShareUrlError('');
      } else if (Object.keys(imageTiktok).length == 0 && !saveDraft) {
        setBackendError(t('error_info_tiktok'));
        setLoader(false);
        return;
      }
      campaignData.tiktokContents = socialContent.tiktok;
    }

    campaignData.startDate = new Date(
      `${startDate.getFullYear()}/${
        startDate.getMonth() + 1
      }/${startDate.getDate()} ${hourt}:${minutes}`
    ).toString();
    campaignData.finishDate = new Date(
      `${finishDate.getFullYear()}/${
        finishDate.getMonth() + 1
      }/${finishDate.getDate()} 22:59:59`
    ).toString();
    campaignData.companyId = currentUser.user.companyId;
    campaignData.ambassadorsIds = ambassadors;
    campaignData.groupsIds = group;
    if (campaignStatus === 'draft' && !saveDraft) {
      campaignData.status = 'publish';
    } else {
      campaignData.status = campaignStatus;
    }

    if (editImage.photo && image.length > 0) {
      const namePhoto = generateRandAlphaNumStr();
      const uploadedPhoto = await awsUploadFileHelper(
        currentUser?.token,
        image,
        true,
        'CAMPAIGN',
        namePhoto,
        t,
        setBackendError
      );
      if (uploadedPhoto) {
        campaignData.photo = getUrlS3('campaigns', namePhoto);
      } else {
        setBackendError(t('validations:file_error'));
        setLoader(false);
        return;
      }
    } else if (!editImage.photo) {
      campaignData.photo = campaign?.photo;
    }

    let facebook: any;
    if (campaignData.includesFacebook) {
      if (editImage.facebook && Object.keys(imageFacebook).length > 0) {
        if (type.facebook === 'image') {
          const nameFacebook = setFileNameHelper(imageFacebook[0], false);
          const uploadedFacebookPhoto = await awsUploadFileHelper(
            currentUser?.token,
            imageFacebook[0],
            false,
            'CAMPAIGN',
            nameFacebook,
            t,
            setBackendError
          );
          if (uploadedFacebookPhoto) {
            facebook = {
              type: type['facebook'],
              url: [getUrlS3('campaigns', nameFacebook)]
            };
          } else {
            setBackendError(t('validations:file_error'));
            setLoader(false);
            return;
          }
        }
        if (type.facebook === 'video') {
          setUploadedFacebook(false);
          const nameFacebook = setFileNameHelper(imageFacebook, false);
          const uploadedFacebook = await awsUploadVideoHelper(
            currentUser?.token,
            imageFacebook,
            'CAMPAIGN',
            nameFacebook,
            t,
            setBackendError
          );
          if (uploadedFacebook) {
            facebook = {
              type: type['facebook'],
              url: getUrlS3('campaigns', nameFacebook)
            };
            setUploadedFacebook(true);
          } else {
            setBackendError(t('validations:file_error'));
            setLoader(false);
            return;
          }
        }
      } else if (!editImage.facebook) {
        if (campaign?.contentPerSocialNetwork?.facebook?.type === 'image') {
          facebook = campaign?.contentPerSocialNetwork?.facebook?.picturesUrls;
        } else {
          facebook = campaign?.contentPerSocialNetwork?.facebook?.videoUrl;
        }

        facebook = {
          type: campaign?.contentPerSocialNetwork?.facebook?.type,
          url: facebook
        };
      }
    }

    let twitter: any;
    if (editImage.twitter && Object.keys(imageTwitter).length > 0) {
      if (type.twitter === 'image') {
        const twitterFile = [];
        if (imageTwitter) {
          setUploadedTwitter(false);
        }
        for (const file of imageTwitter) {
          if (!file?.file?.type) {
            const name = file.url.split('/').reverse()[0];
            twitterFile.push({ name });
            continue;
          }
          const nameTwitter = setFileNameHelper(file, false);
          await awsUploadFileHelper(
            currentUser?.token,
            file,
            false,
            'CAMPAIGN',
            nameTwitter,
            t,
            setBackendError
          );
          twitterFile.push({ name: nameTwitter });
        }
        twitter = {
          type: type['twitter'],
          url: twitterFile.map((file: any) => getUrlS3('campaigns', file?.name))
        };
      }
      if (type.twitter === 'video') {
        setUploadedTwitter(false);
        const nameTwitter = setFileNameHelper(imageTwitter, false);
        const uploadedTwitter = await awsUploadVideoHelper(
          currentUser?.token,
          imageTwitter,
          'CAMPAIGN',
          nameTwitter,
          t,
          setBackendError
        );
        if (uploadedTwitter) {
          twitter = {
            type: type['twitter'],
            url: getUrlS3('campaigns', nameTwitter)
          };
          setUploadedTwitter(true);
        } else {
          setBackendError(t('validations:file_error'));
          setLoader(false);
          return;
        }
      }
    } else if (!editImage.twitter) {
      if (campaign?.contentPerSocialNetwork?.twitter?.type === 'image') {
        twitter = campaign?.contentPerSocialNetwork?.twitter?.picturesUrls;
      } else {
        twitter = campaign?.contentPerSocialNetwork?.twitter?.videoUrl;
      }

      twitter = {
        type: type['twitter'],
        url: twitter
      };
    }

    let linkedin: any;
    if (editImage.linkedin && Object.keys(imageLinkedin).length > 0) {
      if (type.linkedin === 'image') {
        const linkedinFile = [];
        if (imageLinkedin) {
          setUploadedLinkedin(false);
        }
        for (const file of imageLinkedin) {
          if (!file?.file?.type) {
            const name = file.url.split('/').reverse()[0];
            linkedinFile.push({ name });
            continue;
          }
          const nameLinkedin = setFileNameHelper(file, false);
          await awsUploadFileHelper(
            currentUser?.token,
            file,
            false,
            'CAMPAIGN',
            nameLinkedin,
            t,
            setBackendError
          );
          linkedinFile.push({ name: nameLinkedin });
        }
        linkedin = {
          type: type['linkedin'],
          url: linkedinFile.map((file: any) =>
            getUrlS3('campaigns', file?.name)
          )
        };
      }
      if (type.linkedin === 'video') {
        setUploadedLinkedin(false);
        const nameLinkedin = setFileNameHelper(imageLinkedin, false);
        const uploadedLinkedin = await awsUploadVideoHelper(
          currentUser?.token,
          imageLinkedin,
          'CAMPAIGN',
          nameLinkedin,
          t,
          setBackendError
        );
        if (uploadedLinkedin) {
          linkedin = {
            type: type['linkedin'],
            url: getUrlS3('campaigns', nameLinkedin)
          };
          setUploadedLinkedin(true);
        } else {
          setBackendError(t('validations:file_error'));
          setLoader(false);
          return;
        }
      }
      if (type.linkedin === 'pdf') {
        const nameLinkedin = setFilePdfHelper(imageLinkedin[0].name);
        const uploadedLinkedin = await awsUploadFileHelper(
          currentUser?.token,
          imageLinkedin[0],
          false,
          'CAMPAIGN',
          `${currentUser.user.companyId}/${nameLinkedin}`,
          t,
          setBackendError
        );
        if (uploadedLinkedin) {
          linkedin = {
            type: type['linkedin'],
            url: getUrlS3(
              `campaigns/${currentUser.user.companyId}`,
              nameLinkedin
            )
          };
        } else {
          setBackendError(t('validations:file_error'));
          setLoader(false);
          return;
        }
      }
    } else if (!editImage.linkedin) {
      if (campaign?.contentPerSocialNetwork?.linkedin?.type === 'image') {
        linkedin = campaign?.contentPerSocialNetwork?.linkedin?.picturesUrls;
      } else if (
        campaign?.contentPerSocialNetwork?.linkedin?.type === 'video'
      ) {
        linkedin = campaign?.contentPerSocialNetwork?.linkedin?.videoUrl;
      } else {
        linkedin = campaign?.contentPerSocialNetwork?.linkedin?.pdfUrl;
      }

      linkedin = {
        type: type['linkedin'],
        url: linkedin
      };
    }
    if (type.linkedin === 'share') {
      if (linkedinUrn) {
        linkedin = {
          type: type['linkedin'],
          url: linkedinUrn,
          contentParticipation: socialContent.linkedin.content
        };
      } else {
        setLinkedinUrnError(t('error_urn_linkedin'));
        setLoader(false);
        return;
      }
    }

    let instagram: any;
    if (campaignData.includesInstagram) {
      if (type.instagram === 'share') {
        instagram = {
          type: type['instagram'],
          url: instagramShareUrl,
          contentParticipation: campaignData.contentInstagram
        };
      } else if (
        editImage.instagram &&
        Object.keys(imageInstagram).length > 0
      ) {
        if (type.instagram === 'image') {
          const nameInstagram = setFileNameHelper(imageInstagram[0], false);
          const uploadedInstagramPhoto = await awsUploadFileHelper(
            currentUser?.token,
            imageInstagram[0],
            false,
            'CAMPAIGN',
            nameInstagram,
            t,
            setBackendError
          );
          if (uploadedInstagramPhoto) {
            instagram = {
              type: type['instagram'],
              url: [getUrlS3('campaigns', nameInstagram)]
            };
          } else {
            setBackendError(t('validations:file_error'));
            setLoader(false);
            return;
          }
        }
        if (type.instagram === 'video') {
          setUploadedInstagram(false);
          const nameInstagram = setFileNameHelper(imageInstagram, false);
          const uploadedInstagram = await awsUploadVideoHelper(
            currentUser?.token,
            imageInstagram,
            'CAMPAIGN',
            nameInstagram,
            t,
            setBackendError
          );
          if (uploadedInstagram) {
            instagram = {
              type: type['instagram'],
              url: getUrlS3('campaigns', nameInstagram)
            };
            setUploadedInstagram(true);
          } else {
            setBackendError(t('validations:file_error'));
            setLoader(false);
            return;
          }
        }
      } else if (!editImage.instagram) {
        if (campaign?.contentPerSocialNetwork?.instagram?.type === 'image') {
          instagram =
            campaign?.contentPerSocialNetwork?.instagram?.picturesUrls;
        } else {
          instagram = campaign?.contentPerSocialNetwork?.instagram?.videoUrl;
        }

        instagram = {
          type: campaign?.contentPerSocialNetwork?.instagram?.type,
          url: instagram
        };
      }
    }

    let whatsapp: any;
    if (campaignData.includesWhatsapp) {
      if (editImage.whatsapp && Object.keys(imageWhatsapp).length > 0) {
        if (type.whatsapp === 'image') {
          const nameWhatsapp = setFileNameHelper(imageWhatsapp[0], false);
          const uploadedWhatsappPhoto = await awsUploadFileHelper(
            currentUser?.token,
            imageWhatsapp[0],
            false,
            'CAMPAIGN',
            nameWhatsapp,
            t,
            setBackendError
          );
          if (uploadedWhatsappPhoto) {
            whatsapp = {
              type: type['whatsapp'],
              url: [getUrlS3('campaigns', nameWhatsapp)]
            };
          } else {
            setBackendError(t('validations:file_error'));
            setLoader(false);
            return;
          }
        }
        if (type.whatsapp === 'video') {
          setUploadedWhatsapp(false);
          const nameWhatsapp = setFileNameHelper(imageWhatsapp, false);
          const uploadedWhatsapp = await awsUploadVideoHelper(
            currentUser?.token,
            imageWhatsapp,
            'CAMPAIGN',
            nameWhatsapp,
            t,
            setBackendError
          );
          if (uploadedWhatsapp) {
            whatsapp = {
              type: type['whatsapp'],
              url: getUrlS3('campaigns', nameWhatsapp)
            };
            setUploadedWhatsapp(true);
          } else {
            setBackendError(t('validations:file_error'));
            setLoader(false);
            return;
          }
        }
      } else if (!editImage.whatsapp) {
        if (campaign?.contentPerSocialNetwork?.whatsapp?.type === 'image') {
          whatsapp = campaign?.contentPerSocialNetwork?.whatsapp?.picturesUrls;
        } else {
          whatsapp = campaign?.contentPerSocialNetwork?.whatsapp?.videoUrl;
        }

        whatsapp = {
          type: campaign?.contentPerSocialNetwork?.whatsapp?.type,
          url: whatsapp
        };
      }
    }

    let tiktok: any;
    if (type.tiktok === 'share') {
      tiktok = {
        type: type['tiktok'],
        url: tiktokShareUrl,
        contentParticipation: socialContent.tiktok.content
      };
    } else if (editImage.tiktok && Object.keys(imageTiktok).length > 0) {
      if (type.tiktok === 'video') {
        setUploadedTiktok(false);
        const nameTiktok = setFileNameHelper(imageTiktok, false);
        const uploadedTiktok = await awsUploadVideoHelper(
          currentUser?.token,
          imageTiktok,
          'CAMPAIGN',
          nameTiktok,
          t,
          setBackendError
        );
        if (uploadedTiktok) {
          tiktok = {
            type: type['tiktok'],
            url: getUrlS3('campaigns', nameTiktok)
          };
          setUploadedTiktok(true);
        } else {
          setBackendError(t('validations:file_error'));
          setLoader(false);
          return;
        }
      }
    } else if (!editImage.tiktok) {
      tiktok = campaign?.contentPerSocialNetwork?.tiktok?.videoUrl;
      tiktok = {
        type: type['tiktok'],
        url: tiktok
      };
    }

    const { data, errors } = await updateCampaign(
      currentUser?.token,
      campaignData,
      facebook,
      twitter,
      linkedin,
      instagram,
      tiktok,
      whatsapp,
      Number(campaignId),
      type,
      campaign,
      pointsValue
    );

    if (data) {
      history.push('/admin/campaigns', t('edit_success'));
    }
    if (errors) {
      setBackendError(errors.data);
      setLoader(false);
    }
    setLoader(false);
  };

  return (
    <>
      {backendSuccess && (
        <SuccessAlert
          text={backendSuccess}
          allowClose={true}
          onClose={() => setBackendSuccess(null)}
        />
      )}

      {backendError && (
        <ErrorAlert
          text={backendError}
          allowClose={true}
          onClose={() => setBackendError(null)}
        />
      )}

      <EditCampaignForm
        onSubmit={handleSubmit(onSubmit)}
        register={register}
        errors={errors}
        handleClick={handleClick}
        groupsAmbassador={groupsAmbassador}
        getData={getGroup}
        handleParticipation={handleParticipation}
        handleImage={handleImagen}
        campaign={campaign}
        handleTypeFile={handleTypeFile}
        control={control}
        type={type}
        setImageFacebook={setImageFacebook}
        setImageTwitter={setImageTwitter}
        setImageLinkedin={setImageLinkedin}
        setImageInstagram={setImageInstagram}
        setImageWhatsapp={setImageWhatsapp}
        setImageTiktok={setImageTiktok}
        loader={loader}
        setHourt={setHourt}
        setMinutes={setMinutes}
        sHour={hourt}
        sMinutes={minutes}
        setBackendError={setBackendError}
        contentLimits={contentLimits}
        invalidLimit={invalidLimit}
        uploadedFacebook={uploadedFacebook}
        uploadedTwitter={uploadedTwitter}
        uploadedLinkedin={uploadedLinkedin}
        uploadedInstagram={uploadedInstagram}
        uploadedWhatsapp={uploadedWhatsapp}
        uploadedTiktok={uploadedTiktok}
        linkedinUrn={linkedinUrn}
        setLinkedinUrn={setLinkedinUrn}
        linkedinUrnError={linkedinUrnError}
        setLinkedinUrnError={setLinkedinUrnError}
        instagramShareUrl={instagramShareUrl}
        setInstagramShareUrl={setInstagramShareUrl}
        instagramShareUrlError={instagramShareUrlError}
        setInstagramShareUrlError={setInstagramShareUrlError}
        tiktokShareUrl={tiktokShareUrl}
        setTiktokShareUrl={setTiktokShareUrl}
        tiktokShareUrlError={tiktokShareUrlError}
        setTiktokShareUrlError={setTiktokShareUrlError}
        checkBox={checkBox}
        setCheckBox={setCheckBox}
        socialContent={socialContent}
        setSocialContent={setSocialContent}
        setSaveDraft={setSaveDraft}
        allowFBFanpage={allowFBFanpage}
        setAllowFBFanpage={setAllowFBFanpage}
      />
    </>
  );
};

export default EditCampaignNewPage;
